<script>
import BaseTreeItem from './BaseTreeItem';

export default {
  functional: true,
  props: {
    items: {
      type: Array,
      default: () => []
    },

    offset: {
      type: Object,
      default: () => ({})
    },

    additionalOffset: {
      type: Object,
      default: () => ({})
    },

    index: {
      type: [String, Number],
      default: null
    }
  },

  render(createElement, { props, data } = {}) {
    const { items, offset, additionalOffset, index } = props;
    const { class: className = {}, ...otherData } = data;

    function extractTree(items) {
      // const offsets = new Array(items.length).fill(0);

      const timeLineListItems = items.map(
        ({
          children = [],
          class: timeLineListItemClass = {},
          itemClass = {},
          style = {},
          attrs = {},
          on = {},
          ...props
        } = {}) => {
          let subTileLineItems = [];

          if (children.length) {
            subTileLineItems = extractTree(children);
          }

          const timeLineItem = createElement(
            BaseTreeItem,
            {
              class: timeLineListItemClass,
              itemClass,
              props: {
                ...props
              },
              style,
              attrs,
              on: {
                ...on
                // "update:offset": (offset) => {
                //   offsets[index] = offset;
                //   if (onOffsetUpdated) {
                //     onOffsetUpdated(
                //       offsets.reduce((acc, offset) => acc + offset, 0)
                //     );
                //   }
                // },
              }
            },
            [subTileLineItems]
          );

          return timeLineItem;
        }
      );

      let listStyle = {};
      let treeOffset = 0;

      if (index && offset && offset[index]) {
        if (Array.isArray(offset[index])) {
          treeOffset += offset[index].reduce((acc, value) => {
            return acc + value;
          }, 0);
        } else {
          treeOffset += parseFloat(offset[index]);
        }
      }

      // let additionalLength = 0;

      if (index && additionalOffset && additionalOffset[index]) {
        if (Array.isArray(additionalOffset[index])) {
          // additionalLength = additionalOffset[index].length;
          treeOffset += additionalOffset[index].reduce((acc, value) => {
            if (typeof value === 'object' && value !== null) {
              return (
                acc +
                Object.values(value).reduce((valueAcc, valueArr) => {
                  return (
                    valueAcc +
                    valueArr.reduce((valueArrAcc, valueArrValue) => {
                      return valueArrAcc + valueArrValue;
                    }, 0)
                  );
                }, 0)
              );
            } else {
              return acc + value;
            }
          }, 0);
        } else {
          // additionalLength = 1;

          treeOffset += parseFloat(additionalOffset[index]);
        }
      }

      if (treeOffset > 0) {
        listStyle = {
          ...listStyle,
          marginBottom: `${treeOffset}px`
        };
      }

      return createElement(
        'div',
        {
          class: { ...className, 'timeline-list': true },
          style: listStyle,
          ...otherData
        },
        [timeLineListItems]
      );
    }

    const mainTreeNode = extractTree(items);

    return mainTreeNode;
  }
};
</script>

<style lang="scss" scoped>
// .timeline-item {
//   &:last-child {
//     position: absolute;
//     padding-top: 0;
//     padding-bottom: 0;
//     margin-bottom: 2rem;
//   }

//   &--branch {
//     background: transparent;
//     border-bottom: 4px solid #dfe0ea;
//     border-left: 4px solid #dfe0ea;
//     width: 25px;
//     border-radius: 10px;
//     left: -32px;
//     border-top-left-radius: 0;
//     border-bottom-right-radius: 0;
//   }
// }

.timeline-list {
  &::before {
    height: calc(100% + 10px);
  }

  margin-bottom: 4rem;
}
</style>
